import { LoaderSizeType } from '../types/loader-size.type';

export const LOADER_INDICATOR_COLOR = '#194f90';
export const LOADER_BACKDROP_COLOR = '#80d0ff80';

export const GLOBAL_LOADER_NAME = 'global';

export const LOADER_SIZE_TO_TEXT_CLASS: Record<LoaderSizeType, string> = {
  small: 'le-title-small',
  medium: 'le-title-medium',
  large: 'le-title-large',
};
